import { useQuery } from "@apollo/client";
import { useJsonForms, withJsonFormsMultiEnumProps } from "@jsonforms/react";
import { Dropdown } from "pepsico-ds";
import { useMemo } from "react";
import getPartnerCodeGroups from "../../../graphql/queries/listPartnerCodeGroups";
import {
  useDropdownOptions,
  useDropdownSelection,
  useQueryItems,
} from "../shared/dropdownUtils";
import "./partnerCodeGroupDropdown.scss";

const PartnerCodeGroupDropdownComponent = (props) => {
  const { handleChange, label, path, required, visible, data, uischema } = props;
  const ctx = useJsonForms();
  const jsonformState = ctx.core.data;

  const {
    variables = {},
    readonly,
    disabled,
    placeholder,
    selection = "single",
    filterKey,
  } = uischema.options || {};

  const inputVariables = useMemo(() => {
    return {
      ...variables,
      filter: {
        ...variables?.filter,
        partnerId: jsonformState?.[filterKey] || "",
      },
    };
  }, [jsonformState, filterKey, variables]);

  const { data: queryData } = useQuery(getPartnerCodeGroups, {
    variables: inputVariables,
  });

  // Use shared utility hooks
  const items = useQueryItems(queryData);
  const options = useDropdownOptions(items);
  const [selected, handleSelect] = useDropdownSelection(
    data,
    options,
    selection,
    handleChange,
    path
  );

  if (!visible) return null;

  return (
    <div className="partner-code-group-select-component multiple-select-wrap">
      <Dropdown
        childList={options}
        selection={selection}
        label={label}
        disabled={
          readonly ||
          disabled ||
          uischema?.options?.readonly ||
          uischema?.options?.disabled
        }
        selectedValue={selected}
        isRequired={required}
        setSelectedValue={handleSelect}
        placeholder={placeholder || ""}
      />
    </div>
  );
};

export const PartnerCodeGroupDropdownControl = withJsonFormsMultiEnumProps(
  PartnerCodeGroupDropdownComponent
);
